import rest from './shmRest';
import {shmSearch} from './shmSearch';

const restService = new rest.RestService('/shinomontazh');
const restQuery = new rest.Query(restService, '/shops');

export const shmSort = {
    config: {
        sortBlock: '.block-sort',
        sortItem: '.block-sort-item',
        sortItemSelected: 'block-sort-item--selected',
        sortItemDesc: 'block-sort-item--desc',
        sort: ['rating', true],
    },
    bindEvents: function() {
        $(shmSort.config.sortItem).on('click', function() {
            shmSort.markSelectedSelector(this);
            shmSort.doSort();
            restQuery.when(window.whenBlock.getDateTime());
            restQuery.evaluate(shmSearch.evaluateCallback);
        });
    },
    init: function(blockSortSelect) {
        this.bindEvents();
        this.doSort();
    },
    doSort: (newSort = shmSort.config.sort) => {
        const sort = shmSort.config.sort;
        const sortSelector = `[data-sort="${newSort[0]}"]`;
        restQuery.order(sort[0], sort[1]);

        $('.block-sort-item').removeClass(shmSort.config.sortItemSelected);
        $(sortSelector).addClass(shmSort.config.sortItemSelected);

        if (newSort[1]) {
            $(sortSelector).addClass(shmSort.config.sortItemDesc);
        }

        shmSort.config.sort = newSort;
    },
    getSort: function() {
        return shmSort.config.sort;
    },
    markSelectedSelector: function(selector) {
        if ($(selector).hasClass(shmSort.config.sortItemSelected)) {
            $(selector).toggleClass(shmSort.config.sortItemDesc);
        } else {
            $(shmSort.config.sortItem).each(function() {
                if (this == selector) {
                    $(this).addClass(shmSort.config.sortItemSelected);
                } else {
                    $(this).removeClass(shmSort.config.sortItemSelected);
                    $(this).removeClass(shmSort.config.sortItemDesc);
                }
            });
        }

        const isAsc = $(selector).hasClass(shmSort.config.sortItemDesc) ? true : false;
        const sort = $(selector).data('sort');
        shmSort.config.sort = [sort, isAsc];
    },
};
